import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  addDoctorUpcomingEvent,
  deleteDoctorUpcomingEvent,
  doctorUpcomingEventById,
  getAvailableSlots,
  getDoctorUpcomingEventList,
  updateDoctorUpcomingEvent,
} from "../../services/DoctorService";
import {
  formatNewDate,
  formatAMPM,
  showToastError,
  showToastSuccess,
  filterSoftDeletedClient,
  formatWithoutChangedinLocal,
  formatDateStringDDMMYYYY,
  sortByName,
} from "../../Utils/Helper";
import { timezone, toastMsg } from "../../Utils/AllConstant";
import DateInput from "../../commonComponent/CutomDatePicker";
import { AiOutlinePlus } from "react-icons/ai";
import EventViewModal from "./EventViewModal";
import AssignGroups from "./AssignGroups";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../commonComponent/DeleteModal";
import { getServiceList } from "../../services/MyService";
import AssignClientsNew from "./AssignClients_New";
import {
  getMyAssignedPatientList,
  getMyPatientList,
  getPatientList,
} from "../../services/PatientService";
import { getMyGroupList } from "../../services/GroupService";
import { FiEdit, FiTrash } from "react-icons/fi";
import moment from "moment";
import { createZoomMeetingService } from "../../services/ZoomService";
import { useAuth } from "../../Context/AuthContext";
import Loader from "../../commonComponent/Loader";

const MyEvents = () => {
  // console.log(addMonths(startOfMonth(new Date()),3));
  // eslint-disable-next-line
  const navigate = useNavigate(); // eslint-disable-next-line
  const [startDate, setStartDate] = useState(new Date()); // eslint-disable-next-line
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [eventDate, setEventDate] = useState(new Date());
  const [eventFee, setEventFee] = useState("");
  const [eventTitle, setEventTitle] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [eventNotes, setEventNotes] = useState("");
  const [endTime, setEndTime] = useState(""); // eslint-disable-next-line
  const [startTime24, setStartTime24] = useState(""); // eslint-disable-next-line
  const [endTime24, setEndTime24] = useState(""); // eslint-disable-next-line
  const [showTimePicker, setTimePickerVisible] = useState(false); // eslint-disable-next-line
  const [showEndTimePicker, setEndTimePickerVisible] = useState(false); // eslint-disable-next-line
  const [duration, setDuration] = useState("");
  const [appointmentType, setAppointmentType] = useState(""); // eslint-disable-next-line
  const [frequency, setFrequency] = useState(""); // eslint-disable-next-line
  const [durationObject, setDurationObject] = useState(""); // eslint-disable-next-line
  const [timeZoneObject, setTimeZoneObject] = useState({}); // eslint-disable-next-line
  const [weekDays, setWeekDays] = useState([1]);
  const [error, setError] = useState(false); // eslint-disable-next-line
  const [loaded, setLoaded] = useState(false);
  const [modalShow, setModalShow] = useState(false); // eslint-disable-next-line
  const [isLoading, setLoader] = useState(true);
  const [serviceList, setServiceList] = useState([]);
  const [service, setService] = useState([]); // eslint-disable-next-line
  const [selectedDate, setSelectedDate] = useState(new Date()); // eslint-disable-next-line
  const [toastShow, setToastShow] = useState(false); // eslint-disable-next-line
  const [dateVal, setdateVal] = useState(false); // eslint-disable-next-line
  const [weekVal, setweekVal] = useState(false);
  const [members, setMembers] = useState([]);
  const [timeList, setTimeList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [upcomingList, setUpcomingList] = useState([]);
  const [eventId, setEventId] = useState("");
  const [fullMemberList, setFullMemberList] = useState([]);
  const [groupLists, setGroupLists] = useState([]);
  const [foundObjectNames, setFoundNames] = useState(null);
  const [foundGroupNames, setFoundGroupNames] = useState(null);
  const [updateMode, setUpdateMode] = useState(false);
  const [zoomLink, setZoomLink] = useState(false);
  const [doctorLink, setDoctorLink] = useState("");
  const [userLink, setUserLink] = useState("");
  const { isAdmin } = useAuth();
  const getEventList = async () => {
    try {
      const response = await getDoctorUpcomingEventList();
      if (response.status === 200) {
        setUpcomingList(response?.data?.data);

        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const validateFields = () => {
    // Reset all error states
    let isValid = false;
    setError(false);
    // Validate title
    if (!eventTitle || eventTitle.trim() === "") {
      setError(true);
      return isValid;
    }

    // Validate description
    if (!eventDescription || eventDescription.trim() === "") {
      setError(true);
      return isValid;
    }

    // Validate service title
    if (!service) {
      setError(true);
      return isValid;
    }

    // Validate service type
    if (!appointmentType) {
      setError(true);
      return isValid;
    }

    // Validate date
    if (!eventDate) {
      setError(true);
      return isValid;
    }

    // Validate start time
    if (!startTime) {
      setError(true);
      return isValid;
    }

    // Validate end time
    if (!endTime) {
      setError(true);
      return isValid;
    }

    isValid = true;
    setError(false);
    return isValid;
  };

  const getMyServiceList = async () => {
    try {
      const response = await getServiceList();

      if (response.status === 200) {
        setServiceList(response?.data?.data);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    getEventList();
    // getAvailabilityList();
    // getTodaysBookingList(initialDate);
    // setTimeZoneObject(timezone[0]);
    getPatientLists();
    getTimeSlots(new Date());
    getMyServiceList(); // eslint-disable-next-line
  }, []);

  // Delete list event
  const deleteEvent = async (id) => {
    try {
      const response = await deleteDoctorUpcomingEvent(id);
      if (response) {
        showToastSuccess("Event deleted");
        getEventList();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };
  const getPatientLists = async (searchWord) => {
    // try {
    //   const response = await getMyPatientList(searchWord);

    //   if (response.status === 200) {
    //     setFullMemberList(filterSoftDeletedClient(response?.data?.data));
    //   }
    // } catch (error) {
    //   setLoader(false);
    //   console.log(error);
    // }

    try {
      let assignedPatientResponse;
      let allPatientResponse;

      // Assuming isAdmin is a boolean indicating whether the user is an admin
      if (!isAdmin) {
        assignedPatientResponse = await getMyAssignedPatientList();
      }
      allPatientResponse = await getPatientList();

      setLoader(false);

      if (allPatientResponse.status === 200) {
        const assignedPatientData = assignedPatientResponse?.data?.data || [];
        const allPatientData = allPatientResponse?.data?.data || [];
        const combinedData = [...allPatientData];

        if (assignedPatientData.length > 0) {
          combinedData.push(...assignedPatientData);
        }
        let sortedData = sortByName(filterSoftDeletedClient(combinedData));
        setFullMemberList(sortedData);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
    setGroupLists([]);
    // setMembers([])

    try {
      const response = await getMyGroupList();
      setLoader(false);
      if (response.status === 200) {
        setGroupLists(response?.data?.data);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const getTimeSlots = async (type, date) => {
    try {
      const response = await getAvailableSlots({
        date: format(date, "yyyy-MM-dd"),
        type: type,
        serviceId: type.value,
      });
      if (response.status === 200) {
        // console.log(response, "booking data");
        setTimeList(response.data.data.length > 0 ? response?.data?.data : []);
      } else {
        alert(response?.data || response.message);
      }
      //    setLoader(false)
    } catch (error) {
      error?.data?.data && alert(error?.data?.data || error.data?.message);
    }
  };

  const availableTimings = () => {
    const options = timeList.map((dt) => {
      return {
        value: formatAMPM(dt.start) + "-" + formatAMPM(dt.end),
        label: formatAMPM(dt.start),
      };
    });

    return options || [];
  };

  const createMeeting = async () => {
    try {
      const meetingDetail = {
        topic: eventTitle,
        type: 8,
        start_time: startTime.label,
        duration: duration,
        recurrence: {
          end_date_time: endTime,
          monthly_week: 1,
          monthly_week_day: 1,
          repeat_interval: 2,
          type: 2,

          // "weekly_days": weekDay[sessionWeeks],
        },
        settings: {
          host_video: true,
          participant_video: true,
          join_before_host: true,
          mute_upon_entry: "true",
          watermark: "true",
          audio: "voip",
          auto_recording: "cloud",
          email_notification: true,
          registrants_email_notification: true,
        },
      };

      const meetingResponse = await createZoomMeetingService(meetingDetail);
      if (meetingResponse) {
        return meetingResponse;
      }
    } catch (error) {
      if (error?.data?.data) {
        navigate("/myprofile");
        showToastError(
          error?.data?.data || error.data?.message || "Some error occurred"
        );
      }
    }
  };

  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    if (!eventLocation && !zoomLink) {
      setError(true);
      return;
    }
    let params = {
      ...(updateMode && { eventId: eventId }),
      eventLink_doctor: zoomLink ? doctorLink : "",
      eventLink_user: zoomLink ? userLink : "",
      serviceId: service.value,
      title: eventTitle,
      description: eventDescription,
      serviceType: service.label,
      appointmentType: appointmentType.label,
      startTime: startTime?.label
        ? format(eventDate, "yyyy-MM-dd") +
          "T" +
          moment(startTime?.label.toUpperCase(), ["h:mm A"]).format(
            "HH:mm:ss"
          ) +
          ".000Z"
        : startTime,
      endTime: endTime
        ? format(eventDate, "yyyy-MM-dd") +
          "T" +
          moment(endTime.toUpperCase(), ["h:mm A"]).format("HH:mm:ss") +
          ".000Z"
        : startTime,
      eventDate: format(eventDate, "yyyy-MM-dd"),
      location: zoomLink ? "" : eventLocation,
      clients: members,
      groups: groups,
      notes: eventNotes,
      rate: eventFee,
      currency: "USD",
    };
    if (zoomLink && !params.eventLink_doctor) {
      const meetingResponse = await createMeeting();
      if (meetingResponse) {
        params.eventLink_doctor = meetingResponse.start_url;
        params.eventLink_user = meetingResponse.join_url;
        params.location = "";
      } else {
        return;
      }
    }
    try {
      const APIType = updateMode
        ? updateDoctorUpcomingEvent
        : addDoctorUpcomingEvent;
      const response = await APIType(params);
      if (response.status === 200) {
        showToastSuccess(`Successfully Saved!`);
        // setToastShow(true);
        resetValues();
        getEventList();
      } else {
        showToastError(
          response?.data || response.message || toastMsg.errorMssg
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || toastMsg.errorMssg
      );
    }
  };

  const filterServiceList = () => {
    const result = serviceList.map((dt) => {
      if (dt.session && appointmentType?.value === "session") {
        return {
          label: dt.serviceName,
          value: dt._id,
          fee: dt.rate,
          time: dt.duration,
        };
      }
      if (dt.group && appointmentType?.value === "group") {
        return {
          label: dt.serviceName,
          value: dt._id,
          fee: dt.rate,
          time: dt.duration,
        };
      } else {
        return {};
      }
    });
    let res = result.filter((value) => Object.keys(value).length !== 0);
    return res;
  };

  const resetValues = () => {
    setDoctorLink("");
    setUserLink("");
    setZoomLink(false);
    setweekVal(false);
    setdateVal(false);
    setStartDate("");
    setEndDate("");
    setWeekDays([]);
    setLoaded(false);
    setStartTime("");
    setEndTime("");
    setStartTime24("");
    setEndTime24("");
    setError(false);
    setDuration("");
    setDurationObject("");
    setTimeZoneObject(timezone[0]);
    setEventFee("");
    setEventTitle("");
    setEventDescription("");
    setGroups([]);
    setMembers([]);
    setService([]);
    setEventNotes("");
    setEventLocation("");
  };
  useEffect(() => {
    findClientById(members);
    findGroupById(groups); // eslint-disable-next-line
  }, [members, groups]);

  // Function to find member object by id
  const findClientById = (id) => {
    const found = fullMemberList.filter((item) => id.includes(item._id));
    setFoundNames(found);
  };
  // Function to find member object by id
  const findGroupById = (id) => {
    const found = groupLists.filter((item) => id.includes(item._id));
    setFoundGroupNames(found);
  };

  // update function
  const updateEvent = async (id) => {
    setEventId(id);
    // doctorUpcomingEventById
    try {
      const response = await doctorUpcomingEventById(id);
      setLoader(false);
      if (response.status === 200) {
        let data = response?.data?.data[0];
        setUpdateMode(true);
        window.scrollTo({
          top: 780,
          left: 0,
          behavior: "auto",
        });
        setEventTitle(data?.title);
        setEventDescription(data?.description);
        setZoomLink(data?.eventLink_doctor ? true : false);
        setDoctorLink(data?.eventLink_doctor);
        setUserLink(data?.eventLink_user);
        console.log(data);
        console.log(serviceList);

        const service = serviceList.filter(
          (item) => item?.serviceName === data?.serviceType
        );
        // console.log(new Date())
        // setEventDate(data?.eventDate)
        setAppointmentType(
          data?.appointmentType === "Individual Session"
            ? { value: "session", label: "Individual Session" }
            : { value: "group", label: "Group Session" }
        );
        setService({
          label: service[0]?.serviceName,
          value: service[0]?._id,
        });
        setEventFee(data?.rate);
        setStartDate(data?.eventDate);
        setEventDate(new Date(data?.eventDate) || new Date());
        let startTime = formatWithoutChangedinLocal(data?.startTime);
        let endTime = formatWithoutChangedinLocal(data?.endTime);
        setStartTime({ value: startTime, label: startTime });
        setEndTime(endTime);
        setEventLocation(data?.location);
        findClientById(data?.clients);
        findGroupById(data?.groups); // eslint-disable-next-line
        setEventNotes(data?.notes);
        setMembers(data?.clients);
        setGroups(data?.groups);
        getTimeSlots(
          {
            label: service[0].serviceName,
            value: service[0]._id,
          },
          new Date(formatNewDate(data?.eventDate))
        );
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  // eslint-disable-next-line react/jsx-props-no-spreading
  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h4 className="mb-3 chidHeadFont">Upcoming Events</h4>
        </div>
        <div className="col-md-4">
          <div className="row">
            <div className="col-md-4">
              <button
                className="description_btntoday w-100"
                style={{
                  backgroundColor: "#1f7e78",
                  borderColor: "#1f7e78",
                }}
              >
                Today
              </button>
            </div>
            <div className="col-md-8">
              <button
                className="description_btntoday w-100"
                style={{
                  backgroundColor: "#1f7e78",
                  borderColor: "#1f7e78",
                }}
                onClick={() => {
                  window.scrollTo({
                    top: 780,
                    left: 0,
                    behavior: "auto",
                  });
                  resetValues();
                }}
              >
                Add Event
              </button>
            </div>
            {/* <div className="col-md-2">
              <DateInput
                // value={startDateCreate}
                // onChangeDate={(date) => {
                //     setStartDateCreate(date)
                //     setError({ ...error, start_date: false })

                // }}
                // maxDate={endDateCreate}
                minDate={new Date()}
                inputClassName={"description_inputf d-flex align-items-center"}
              />
            </div> */}
          </div>
        </div>
      </div>{
        isLoading && <Loader visible={true}  mainStyle={{ height: "400px" }}/>
      }
      {!isLoading && (
        <div className="table_resouter upcoming_scroll_div">
          {/* {isLoading ? (<center>
                    <Loader visible={isLoading}
                        style={{ top: "-15px", position: "relative" }} /> </center>)
                    : BookingList.length ? ( */}
          {upcomingList.length > 0 && (
            <table className="table appointment_table1 table_resinner2 w-100">
              <thead>
                <tr className="text-center">
                  <th scope="col">title</th>
                  <th scope="col">date</th>
                  <th scope="col">time</th>
                  <th scope="col">location</th>
                  <th scope="col">service</th>
                  <th scope="col">action</th>
                </tr>
              </thead>
              <tbody className="mb-5 ">
                {/* {BookingList.length && BookingList?.map(dt => { */}
                {/* //     console.log(dt.booking_date, "booking_date")
                                      //     let changeDateFormat = dt?.booking_date?.split("-")
                                      //     return  */}
                {upcomingList.length > 0 &&
                  upcomingList.map((dt) => (
                    <tr key={dt._id} className="text-center mt-5">
                      <td>{dt?.title}</td>
                      <td>
                        {/* {format(new Date(dt?.eventDate), "dd-MM-yyyy")} */}
                        {formatDateStringDDMMYYYY(dt?.eventDate)}
                        {/* {dt.age && dt.age} */}
                      </td>
                      <td>
                        {formatWithoutChangedinLocal(dt?.startTime)}
                        {/* {dt.gender && dt.gender} */}
                      </td>
                      <td>
                        {dt?.location || (
                          <a href={dt?.eventLink_doctor} target="_blank">
                            {dt?.eventLink_doctor}
                          </a>
                        )}
                        {/* {`${changeDateFormat[1]}-${changeDateFormat[2]}-${changeDateFormat[0]}`} */}
                      </td>
                      <td className="text_unset">
                        {dt?.serviceType ? dt?.serviceType : "-"}
                        {/* {dt.time} */}
                      </td>
                      <td>
                        <button
                          onClick={() => updateEvent(dt?._id)}
                          className="btn btn-light me-2"
                        >
                          <span>
                            <FiEdit className="mb-1 " />
                          </span>
                        </button>
                        {/* <button
                                  onClick={() => {
                                    navigate("/viewevent");
                                  }}
                                  // onClick={() => onStartSession(dt?.eventLink_doctor)}
                                  className="btn btn-light"
                                >
                                  <span>
                                    <AiFillEye className="mb-1 " />
                                  </span>
                                </button> */}
                        <button
                          className="btn btn-light ms-2"
                          data-bs-toggle="modal"
                          data-bs-target="#deleteEvent"
                          onClick={() => setEventId(dt._id)}
                        >
                          <span>
                            <FiTrash />
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))}

                {/* }
                                  )} */}
              </tbody>
            </table>
          )}
          {
            <Loader
              visible={false}
              noAnyData={!(upcomingList?.length > 0)}
              mainStyle={{ height: "400px" }}
            />
          }
          {/* ) : (<div className="card p-2"><div className="card-body">There are currently no appointments.</div></div>)} */}
        </div>
      )}
      <hr />
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <h4 className="px-1 mb-3 chidHeadFont">Add Events</h4>
            <div
              className="resFont"
              style={{ backgroundColor: "#fff", padding: "10px" }}
            >
              <div className="col-md-12">
                <p className="whole_label resFont">
                  title <span className="text-danger fw-bold ">*</span>
                </p>
                <input
                  type="text"
                  className="description_inputf"
                  value={eventTitle}
                  maxLength={50}
                  onChange={(e) => {
                    setEventTitle(e.target.value);
                    // setError({ ...error, name: false })
                  }}
                />
                {error && !eventTitle && (
                  <h6 className="text-danger  error">
                    Please select appointment type
                  </h6>
                )}
              </div>

              <div className="col-md-12">
                <p className="whole_label resFont">
                  description <span className="text-danger fw-bold ">*</span>
                </p>
                <textarea
                  rows="6"
                  type="text"
                  className="description_inputf description_descpf is-invalid"
                  value={eventDescription}
                  maxLength={300}
                  onChange={(e) => {
                    // setError({ ...error, description: false })
                    setEventDescription(e.target.value);
                  }}
                />
                {error && !eventDescription && (
                  <h6 className="text-danger  error">
                    Please select appointment type
                  </h6>
                )}
              </div>
              <div className="d-flex ">
                <div className="col-md-4 ml-2">
                  <p className="whole_label resFont">
                    Service <span className="text-lowercase">Type</span>{" "}
                    <span className="text-danger fw-bold ">*</span>
                  </p>
                  <Select
                    // isMulti
                    // closeMenuOnSelect={false}
                    placeholder={"Select"}
                    value={appointmentType}
                    options={[
                      { value: "session", label: "Individual Session" },
                      { value: "group", label: "Group Session" },
                    ]}
                    onChange={(opt, meta) => {
                      // getTimeSlots(opt.value);
                      setAppointmentType(opt);
                    }}
                  />
                  {error && appointmentType.length === 0 && (
                    <h6 className="text-danger  error">
                      Please select appointment type
                    </h6>
                  )}
                  {/* {daysDatesError && <h6 className="text-danger  error">Please select weekdays from the dates selected</h6>} */}
                </div>
                <div className="col-md-4 px-4">
                  <p className="whole_label resFont">
                    Service Title{" "}
                    <span className="text-danger fw-bold ">*</span>
                  </p>
                  <Select
                    placeholder={"Select a service"}
                    value={service}
                    options={filterServiceList()}
                    onChange={(opt) => {
                      setService(opt);
                      getTimeSlots(opt, eventDate);
                      setEventFee(opt.fee);
                      setDuration(opt.time);
                    }}
                  />
                  {error && service.length === 0 && (
                    <h6 className="text-danger  error">
                      Please select service
                    </h6>
                  )}
                  {/* {error && frequency.length === 0 && <h6 className="text-danger  error">Please select frequency</h6>} */}
                  {/* {daysDatesError && <h6 className="text-danger  error">Please select weekdays from the dates selected</h6>} */}
                </div>
                <div className="col-md-4 px-1">
                  <p className="whole_label resFont">
                    Fee <span className="text-danger fw-bold ">*</span>
                  </p>
                  <input
                    type="number"
                    className="description_inputf"
                    placeholder="$000"
                    value={eventFee}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^\d+$/.test(inputValue) || inputValue === "") {
                        setEventFee(inputValue);
                      }
                    }}
                  />
                  {error && !eventFee && (
                    <h6 className="text-danger  error">Please add event fee</h6>
                  )}
                  {/* {daysDatesError && <h6 className="text-danger  error">Please select weekdays from the dates selected</h6>} */}
                </div>
              </div>
              <div className="d-flex">
                <div className="col-md-4">
                  <p className="whole_label resFont">
                    date <span className="text-danger fw-bold ">*</span>
                  </p>
                  <DateInput
                    value={eventDate}
                    onChangeDate={(date) => {
                      setEventDate(date);
                      getTimeSlots(service, date);
                      setStartDate(date);
                      setEndDate(date);
                      // setError({ ...error, start_date: false })
                    }}
                    // maxDate={endDateCreate}
                    minDate={new Date()}
                    inputClassName={
                      "description_inputf d-flex align-items-center"
                    }
                  />
                  {/* {error.start_date ?
                                    <h6 className="blog_error_text4" style={{ marginBottom: 15, marginTop: 7 }}>
                                        {'Please select start date'}
                                    </h6> : null} */}
                </div>
                <div className="col-md-4 px-4">
                  <p className="whole_label resFont">
                    start <span className="text-lowercase">time</span>{" "}
                    <span className="text-danger fw-bold ">*</span>
                  </p>
                  <Select
                    placeholder={"Select a time"}
                    value={startTime}
                    options={availableTimings()}
                    onChange={(opt) => {
                      setStartTime(opt);
                      setEndTime(opt?.value.split("-")[1]);
                    }}
                  />
                  {/* <TimePickerModule
                    defaultValue={
                      startTime
                        ? `${moment(startTime, ["h:mm:ss A"]).format("HH:mm")}`
                        : null
                    }
                    setNewData={setStartTime}
                    selectedDate={selectedDate}
                  ></TimePickerModule> */}
                  {/* <TimePicker
                                    value={startTime ? startTime : null}
                                    visibility={showTimePicker}
                                    onChangeDate={startTimeSetting}
                                    onDone={() => setTimePickerVisible(false)}>
                                    <span onClick={() => setTimePickerVisible(!showTimePicker)}>
                                        <input
                                        required
                                        placeholder="--:--"
                                        // disabled
                                        className="description_inputf"
                                        value={startTime}
                                        />
                                        <img src="images/clock.png" className="clock_icon" />
                                    </span>
                                    </TimePicker> */}

                  {error && !startTime && (
                    <h6 className="text-danger error">Please add start time</h6>
                  )}
                </div>

                <div className="col-md-4 px-1">
                  <p className="whole_label resFont">
                    End <span className="text-lowercase">time</span>{" "}
                    <span className="text-danger fw-bold ">*</span>
                  </p>
                  {/* {endTime  && ( */}
                  <input
                    type="text"
                    className="description_inputf"
                    value={endTime}
                  />
                  {/* <TimePickerModule
                    disabled={true}
                    defaultValue={
                      endTime
                        ? `${moment(endTime, ["h:mm:ss A"]).format("HH:mm")}`
                        : null
                    }
                    setNewData={setEndTime}
                    selectedDate={selectedDate}
                  ></TimePickerModule> */}
                  {/* )} */}
                  {/* <TimePicker
                    value={endTime ? endTime : null}
                    visibility={showEndTimePicker}
                    onChangeDate={endTimeSetting}
                    onDone={() => setEndTimePickerVisible(false)}
                  >
                    <span
                      onClick={() =>
                        setEndTimePickerVisible(!showEndTimePicker)
                      }
                    >
                      <input
                        required
                        placeholder="--:--"
                        // disabled
                        className="description_inputf"
                        value={endTime}
                      />
                      <img src="images/clock.png" className="clock_icon" />
                    </span>
                  </TimePicker> */}
                  {error && !startTime && (
                    <h6 className="text-danger error">Please add end time</h6>
                  )}
                  {startTime &&
                    endTime &&
                    new Date("1/1/2022 " + endTime) -
                      new Date("1/1/2022 " + startTime) <
                      1 && (
                      <h6 className="text-danger error">
                        Please enter correct end time
                      </h6>
                    )}
                </div>
              </div>

              {/* <div className="col-md-12">
                    {startTime && 
                    endTime && 
                    ( (new Date('1/1/2022 '+endTime)-new Date('1/1/2022 '+startTime))< 1) 
                    && <h6 className="text-danger error">Please enter correct start and end time</h6>}
                  </div> */}
              <div className="col-md-12">
                <p className="whole_label resFont">
                  Add Location <span className="text-danger fw-bold ">*</span>
                </p>
                <div className="btn-group margin_top_20">
                  <p className="affir_checkbox">
                    <input
                      type="checkbox"
                      checked={zoomLink}
                      onChange={() => setZoomLink(!zoomLink)}
                      //   checked={lifeStyleDetail?.relax?.dailyInput || false}
                    />
                  </p>
                  <p
                    className="affir_checkbox"
                    style={{ fontSize: 16, color: "#156563" }}
                  >
                    {"Create zoom meeting link"}
                  </p>
                </div>
                <textarea
                  type="text"
                  className="description_inputf description_descpf is-invalid"
                  placeholder="Type physical address or leave blank if online only"
                  value={eventLocation}
                  disabled={zoomLink}
                  onChange={(e) => {
                    // setError({ ...error, description: false })
                    setEventLocation(e.target.value);
                  }}
                />
                {error && (!eventLocation || !zoomLink) && (
                  <h6 className="text-danger error">
                    Please enter location or choose option to create meeting
                    link
                  </h6>
                )}
              </div>
              <div className="col-md-12 mb-4">
                <p className="whole_label resFont">Invite participants</p>
                <div className="d-flex justify-content-space-between">
                  <div className="col-md-6">
                    <button
                      type="button"
                      disabled={appointmentType === "group" ? true : false}
                      className="btn btn-primary btn-custom-light-modal1 w-100 "
                      data-bs-toggle="modal"
                      data-bs-target="#assignclientsmodal"
                    >
                      <AiOutlinePlus /> Add Clients
                    </button>
                    <div className="d-flex ">
                      {" "}
                      {foundObjectNames?.length > 0 && (
                        <>
                          {foundObjectNames.length < 3 ? (
                            foundObjectNames.map((obj, i) => (
                              <div key={obj?._id}>
                                <p className="whole_label resFont">
                                  {obj.full_name}
                                  {i < foundObjectNames.length - 1 && `, `}
                                </p>
                              </div>
                            ))
                          ) : (
                            <>
                              {foundObjectNames.slice(0, 3).map((obj, i) => (
                                <div key={obj?._id}>
                                  <p className="whole_label resFont">
                                    {obj.full_name}
                                    {i < 2 && `, `}
                                  </p>
                                </div>
                              ))}
                              <span className="whole_label resFont">
                                &nbsp;+{foundObjectNames.length - 3}
                              </span>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <button
                      type="button"
                      className="btn btn-primary btn-custom-light-modal1 mx-2"
                      style={{ width: "98%" }}
                      data-bs-toggle="modal"
                      data-bs-target="#assigngroupsmodal"
                    >
                      <AiOutlinePlus /> Add Groups
                    </button>
                    <div className="d-flex ">
                      {" "}
                      {foundGroupNames?.length > 0 && (
                        <>
                          {foundGroupNames.length < 3 ? (
                            foundGroupNames.map((obj, i) => (
                              <div key={obj?._id}>
                                <p className="whole_label resFont">
                                  {obj.groupName}
                                  {i < foundGroupNames.length - 1 && `, `}
                                </p>
                              </div>
                            ))
                          ) : (
                            <>
                              {foundGroupNames.slice(0, 3).map((obj, i) => (
                                <div key={obj?._id}>
                                  <p className="whole_label resFont">
                                    {obj.groupName}
                                    {i < 2 && `, `}
                                  </p>
                                </div>
                              ))}
                              <span className="whole_label resFont">
                                {" "}
                                &nbsp;+{foundObjectNames.length - 3}
                              </span>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  <AssignClientsNew members={members} setMembers={setMembers} />
                  <AssignGroups members={groups} setMembers={setGroups} />
                </div>
              </div>
              <div className="col-md-12">
                <p className="whole_label resFont">Notes to attendees</p>
                <textarea
                  rows="6"
                  type="text"
                  maxLength={500}
                  className="description_inputf description_descpf is-invalid"
                  placeholedr="Write here"
                  value={eventNotes}
                  onChange={(e) => {
                    // setError({ ...error, description: false })
                    setEventNotes(e.target.value);
                  }}
                />
                {/* {renderError('Please enter description', error.description)} */}
              </div>
              <div className="col-md-12">
                <p
                  className="affir_checkbox"
                  style={{ fontSize: 16, color: "#156563" }}
                >
                  {" "}
                  <input
                    type="checkbox"
                    //   checked={lifeStyleDetail?.relax?.dailyInput || false}
                  />
                  {"Send a notification to participants"}{" "}
                  <button
                    type="submit"
                    className="description_btnsave float-end"
                  >
                    Submit
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </form>

      {/* <hr /> */}

      <DeleteModal
        title={"Delete"}
        content1={"Are you sure, you want to cancel"}
        content2={"this event?"}
        modalId={"deleteEvent"}
        button2={"No"}
        button1={"Yes"}
        onDelete={(e) => deleteEvent(eventId)}
      />
      <EventViewModal
        // gname={state?.selectedGroup?.groupName}
        // gid={state?.selectedGroup?._id}
        show={modalShow}
        // getGroupPosts={getGroupPosts}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default MyEvents;
